import {useMemo} from "react";
import {useAccessToken} from "../auth";
import {useClientId} from "../ClientIdProvider";
import {createApiClientWithBaseConfig} from "./client";

export function useLockScanApi() {
	const accessToken = useAccessToken();
	const clientId = useClientId();
	return useMemo(() => createLockScanApi(clientId, accessToken), [accessToken]);
}

function createLockScanApi(clientId: string | undefined, accessToken: string | undefined) {
	const {api, withConfig} = createApiClientWithBaseConfig(clientId, accessToken);
	return {
		scanLock: (lockId: string) =>
			api.get(
				"/api/locks/{lockId}",
				withConfig({
					path: {lockId},
				}),
			),
	};
}
